import { ReferralCodeFormValues } from './types';

export const referralCodeDataKeys: { [K in keyof ReferralCodeFormValues]: K } = {
    referralCode: 'referralCode',
};
